import env from '../../env.js';

export const CMS_MARKET_RUNTIME = 'cmsMarketRuntime';

// false restores market-details navigation instead of opening the CMS OrderSlip.
export const CMS_CONTRACT_CLICK_OPEN_ORDERSLIP = env.CMS_CONTRACT_CLICK_OPEN_ORDERSLIP ?? true;

// When false, guests can edit the slip; Buy still requires login before any order is sent.
// Has no effect when CMS_CONTRACT_CLICK_OPEN_ORDERSLIP is false.
export const CMS_CONTRACT_CLICK_OPEN_ORDERSLIP_REQUIRE_AUTHENTICATED = false;

// Default for the CMS modal's legacy showOrderSlip prop (controls the order book).
export const CMS_ORDER_SLIP_MODAL_SHOW_ORDER_BOOK = false;

export const HeadToHeadCardStyle = Object.freeze({
  SplitBarClassic: 1,
  SplitImage: 2,
  SplitBarChunky: 3,
  SummaryWithChart: 4,
});

export const CmsMarketContractListDisplayType = Object.freeze({
  Classic: 'classic',
  Compact: 'compact',
  ColorList: 'colorlist',
});

export const ColorListContestSummaryType = Object.freeze({
  Text: 1,
  Volume: 2,
});

export const ColorListSparkLineSetting = Object.freeze({
  None: 0,
  Default: 1,
  Custom: 2,
});

export const CMS_CONTRACT_AFFILIATIONS = Object.freeze({
  1: { label: 'D', name: 'Democrat', buyName: 'Dem', color: '#24479B' },
  2: { label: 'R', name: 'Republican', buyName: 'Rep', color: '#D22532' },
  3: { label: 'I', name: 'Independent', buyName: 'Ind', color: '#6B7280' },
});

export const COLOR_LIST_MAX_CONTRACTS = 5;

export const COLOR_LIST_STATUS_TEXT_COLORS = Object.freeze({
  tossUp: ['#7e3fb8', '#c598eb'],
  1: [
    ['#687bb4', '#a8b8ef'],
    ['#4168b6', '#87a6f1'],
    ['#244999', '#7398ed'],
  ],
  2: [
    ['#ae6570', '#eda9b1'],
    ['#b44050', '#f28b99'],
    ['#982533', '#ff7889'],
  ],
  3: [
    ['#806922', '#e8d28e'],
    ['#715713', '#dcc168'],
    ['#604509', '#d9b54b'],
  ],
});
